window.trilogPerformance = window.trilogPerformance || {};
window.trilogPerformance.isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1 || (document.body && document.body.classList.contains('template-collection'));
window.trilogPerformance.isProductPage = window.location.pathname.indexOf('/products/') !== -1 || (document.body && document.body.classList.contains('template-product'));
window.trilogPerformance.runWhenIdle = window.trilogPerformance.runWhenIdle || function (callback, timeout) {
    const run = () => callback();

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: timeout || 1500 });
        return;
    }

    window.setTimeout(run, timeout || 500);
};

(function () {

    function initCartWatcher() {
        if (typeof CartWatcher === 'undefined') return;

        const myCartWatcher = new CartWatcher;
        myCartWatcher.init();
    }

    window.trilogPerformance.runWhenIdle(initCartWatcher, 2000);

    function waitForElm(selector) {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver((mutations) => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        });
    }

    async function waitForObject(objPath) {
        let obj = objPath.split('.').reduce((o, p) => o[p], window);
        while (obj === undefined || obj === null) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          obj = objPath.split('.').reduce((o, p) => o[p], window);
        }
        return obj;
      }

    const debounce = (callback, wait) => {
        let timeoutId = null;
        return (...args) => {
          window.clearTimeout(timeoutId);
          timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
          }, wait);
        };
      }

    const runAfterPaint = (callback) => {
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                window.trilogPerformance.runWhenIdle(callback, 700);
            });
        });
    };

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
      }
      
      function getCookie(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
          }
          if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
          }
        }
        return null;
      }

    
    //GTAG for subscribe box click
    if (window.trilogPerformance.isProductPage) {
    waitForElm(".radio-group-main").then((elm) => {
        let atc = document.querySelector(".product-info");
        if (!atc) return;

        atc.addEventListener("click", (e) => {
            if (!e.target.closest('button[type="submit"], button[name="add"], .product-form__submit, buy-buttons button')) return;

            let checkedItem = document.querySelector('.subscribe-box input:checked');
            if (!checkedItem) return;
            let buttonText = checkedItem.id;

            window.trilogPerformance.runWhenIdle(function () {
                gtag("event", "BSE24_SubscribeATC", {
                    event_label: buttonText,
                    send_to: ["G-MPP3ZDYCJ7"],
                });
            }, 1000);
        });
    });
    }

    /*waitForElm("#sidebar-menu > div > div.header-sidebar__scroller > a").then((elm) => {
        const listElements = document.querySelectorAll("#sidebar-menu > div > div.header-sidebar__scroller > ul > li");
        listElements.forEach((element) => {
            if (element.textContent.toLowerCase().includes("sale") || element.textContent.toLowerCase().includes("vente")) {
              console.log(`Found element with text: ${element.textContent}`);
              element.style.color = "#C8102E";
            }
          });
    
    });*/

    //Acadia Wrapper on one time purchase or subscribe

    if (window.trilogPerformance.isProductPage) {
    waitForElm(".bsub-widget__groups-container").then((elm) => {
        waitForObject('window.BOLD.BsubWidget').then((obj) => {
            wrapYotpoSubscribe();
          });        
    });
    }

    function wrapYotpoSubscribe() {
        el1 = document.querySelector('.bsub-widget__wrapper');
        let listdata = document.querySelectorAll(".bsub-options-container fieldset .bsub-option-container");
        let discount_holder =  document.querySelector('.bsub-widget__group-discount-summary');

        let discount = null;
        try{
            let first_yotpo_plan_key = Object.keys(window.BOLD.BsubWidget.sellingPlanGroups)[0];
            discount = window.BOLD.BsubWidget.sellingPlanGroups[first_yotpo_plan_key].selling_plans[0].price_adjustments[0].value;
        }catch (error) {
        }
        
    
        //French Check
        let frenchcheck = document.querySelector('html[lang="fr"]');
        if (el1 && listdata.length == 12 && frenchcheck === null && window.trilog_customization.buy_subscribe_enable && discount ) {
            const regex = /\d*\.?\d+/g;
            let price = getProductFullPrice();
            let discountedPrice = price * (1 - (discount/100));

            el1.classList.add('acadia-wrapped')
            let navList = document.createElement('div');
            navList.classList.add('radio-group-main');
            navList.innerHTML = `
      <div class="subscribe-box one-time" id="one-time-sub" >
        <div class="subscribe-container">
            <input type="radio" id="one-time-purchase" name="subscribe-tab">
            <label for="one-time-sub">${window.trilog_customization.locale.bold_subscribe.one_time_purchase}</label>
            <p class="price-wrap single-price">$${price}</span></p>
        </div>
      </div>
      <div class="subscribe-box" id="subscribing">
        <div class="subscribe-container">
            <input type="radio" id="subscribe-purchase" name="subscribe-tab" >
            <label for="subscribing">${window.trilog_customization.locale.bold_subscribe.subscribe_purchase.replace("{discount}",discount)}</label>
            <p class="price-wrap double-price"><span class="new-price">${discountedPrice.toFixed(2)}</span><span class="strike-through-price"><del>${price.toFixed(2)}</del></span></p>
        </div>
      <div class="subscribe-details-container"></div>
      </div>
      `;

            el1.prepend(navList);

            //trigger
            document.getElementById("one-time-sub").addEventListener("click", function () {
                document.querySelector(".bsub-widget__group input[value='once']").click();
                document.querySelector("#one-time-sub input").click();
            });

            document.getElementById("subscribing").addEventListener("click", function () {
                document.querySelector(".bsub-widget__group + .bsub-widget__group input.bsub-widget__input").click();
                document.querySelector("#subscribing input").click();
            });


            if( document.querySelector('.bsub-options-container').classList.contains('bsub__hidden') ){
                document.getElementById("one-time-sub").click();
            }else{
                document.getElementById("subscribing").click()
            }

            //
            el2 = document.querySelector('.bsub-widget__wrapper .subscribe-details-container');
            let navList1 = document.createElement('div');
            navList1.classList.add('pros-list-wrap');
            let navList1innerHTML = `
      <ul class="subscribe-box-details">
      <li>
      <img class="right-icon" src="https://cdn.shopify.com/s/files/1/0307/4179/0855/files/Vector_Stroke_1.svg?v=1708087238" />
      <p>${window.trilog_customization.locale.bold_subscribe.subscribe_benefit_1.replace("{discount}",discount+'%')}</p>
      </li>
      <li>
      <img class="right-icon" src="https://cdn.shopify.com/s/files/1/0307/4179/0855/files/Vector_Stroke_1.svg?v=1708087238" />
      <p>${window.trilog_customization.locale.bold_subscribe.subscribe_benefit_2}</p>
      </li>
      <li>
      <img class="right-icon" src="https://cdn.shopify.com/s/files/1/0307/4179/0855/files/Vector_Stroke_1.svg?v=1708087238" />
      <p>${window.trilog_customization.locale.bold_subscribe.subscribe_benefit_3}</p>
      </li>
      `;
      if( window.trilog_customization.locale.bold_subscribe.subscribe_benefit_4 != "" ){
        navList1innerHTML += `<li>
        <img class="right-icon" src="https://cdn.shopify.com/s/files/1/0307/4179/0855/files/Vector_Stroke_1.svg?v=1708087238" />
        <p>${window.trilog_customization.locale.bold_subscribe.subscribe_benefit_4}</p>
        </li>`;
      }
      if( window.trilog_customization.locale.bold_subscribe.subscribe_benefit_5 != "" ){
        navList1innerHTML += `<li>
        <img class="right-icon" src="https://cdn.shopify.com/s/files/1/0307/4179/0855/files/Vector_Stroke_1.svg?v=1708087238" />
        <p>${window.trilog_customization.locale.bold_subscribe.subscribe_benefit_5}</p>
        </li>`;
      }

      navList1innerHTML += '</ul>';

      navList1.innerHTML = navList1innerHTML;
            el2.prepend(navList1);

            //dropdown js

            var optionhtml = "";
            
            if (document.querySelector(".bsub-options-container fieldset")) {

                for (let i = 0; i < listdata.length; i++) {
                    if (listdata[i].querySelector("input").checked) {
                        optionhtml += `<option value="` + listdata[i].getAttribute("data-bsub-option") + `" selected>` + listdata[i].querySelector(".bsub-widget__text").innerHTML + `</option>`;
                    } else {
                        optionhtml += `<option value="` + listdata[i].getAttribute("data-bsub-option") + `">` + listdata[i].querySelector(".bsub-widget__text").innerHTML + `</option>`;
                    }

                }

            }

            var selectHTML = `
      <div class="dropdown-wrapper">
      <p class="left-txt">${window.trilog_customization.locale.bold_subscribe.delivery_frequency}:</p>
      <select id="delivery-frequency">
      `+ optionhtml + `
      </select>
      </div>
      `;


            // Append the HTML string to the specified fieldset      
            // get and set price js
            el2.innerHTML += selectHTML;



            document.getElementById("delivery-frequency").addEventListener("change",function (event) {
                let selected_frequency = document.querySelector('.bsub-options-container fieldset input[type="radio"][value="'+event.target.value+'"]');
                selected_frequency.click();
            })


            let $salePriceElement = $('safe-sticky.product-info sale-price');
            if( $salePriceElement.length ){
                const formElement = document.forms[$salePriceElement[0].getAttribute('form')];
                formElement.addEventListener('variant:change', (event) => {
                    const price = Math.round(event.detail.variant.price/100,2);
                    let subscribeBox = document.querySelector('.bsub-widget__wrapper .one-time p.single-price');
                    subscribeBox.textContent = price.toFixed(2);

                    let strikeThroughPriceElement = document.querySelector('.bsub-widget__wrapper .subscribe-box span.strike-through-price del');
                    strikeThroughPriceElement.textContent = price.toFixed(2);

                    let discountedPrice = Math.round((price - (price * discount/100)),2);
                    let newPriceElement = document.querySelector('.bsub-widget__wrapper .subscribe-box p.price-wrap span.new-price');
                    newPriceElement.textContent = '$' + discountedPrice.toFixed(2);
                });
            }
            

        }

        if( frenchcheck ){
            var bsub_wrapper = document.querySelector('.bsub-widget');
            bsub_wrapper.classList.add('d-none')
        }
    }

    function initPDPGlowPointsModal(){
        let popupBtn = $('.pdp-glow-points-btn');
        let popupModal = $('#pdp-glow-points-modal');
        let popupOverlay = $('#glow-points-overlay');
        let header = $('header');

        popupBtn.on('click', function(event) {
            gtag("event", "BSE17_LearnMore", {
              event_label: document.title,
              send_to: ["G-MPP3ZDYCJ7"],
            });
            popupModal.addClass('active');
            popupOverlay.addClass('active');
            header.addClass('overlay-active')
            
        });

        var closeButton = $('#pdp-glow-points-close');
        closeButton.on('click', function(event) {
            popupModal.removeClass('active');
            popupOverlay.removeClass('active');
            header.removeClass('overlay-active')
        });

        popupOverlay.on('click',function(event){
            popupModal.removeClass('active');
            popupOverlay.removeClass('active');
            header.removeClass('overlay-active')
        })

        let fliktySettings = {
            fade: false,
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left'
        };
        var flkty = new Flickity( '#glow-points-carousel', fliktySettings);

        $('.glow-points-button-group').on( 'click', '.glow-points-btn-select', function() {
            var index = $(this).index();
            flkty.select( index );
        });
        flkty.on( 'scroll', function( progress ) {
            let scrollbar = $('.glow_points_popup .swiper-scrollbar-drag');
            progress = Math.max( 0, Math.min( 1, progress ) );
            let pixel_progress = Math.round( 100 * progress )
            scrollbar.css('transform', `translate3d(${pixel_progress}%, 0px, 0px)`);
        });
        let $salePriceElement = $('safe-sticky.product-info sale-price');
        if( $salePriceElement.length ){
            const formElement = document.forms[$salePriceElement[0].getAttribute('form')];
            formElement.addEventListener('variant:change', (event) => {
                const points = Math.floor(event.detail.variant.price/100);
                let elements = document.querySelectorAll('.glow-points-banner-text');
                elements.forEach(element => {
                    const template = element.getAttribute('data-template');
                    const updatedText = template.replace('{count}', points);
                    element.innerText = updatedText;
                });
            });
        }
    }

    function KlaviyoMountCloseButton(button){
        if( ! button.className.includes('close_button_mounted') ){
            button.classList.add('close_btn_mounted');
            let container = button.parentNode;
            var closeButton = document.createElement('a');
            closeButton.href = 'javascript:void(0)';
            closeButton.className = 'needs_close_btn';
            closeButton.textContent = '+';
            
            container.insertBefore(closeButton,button);


            closeButton.addEventListener('click', function(event){
                if (button.className.includes("kl-teaser-")) {
                    const formID = button.className.match(/kl-teaser-(\w+)/)[1];
                    hideElementInCookie(formID);
                    closeButton.parentNode.remove();
                }
                
            })

            checkAndHideElementFromCookie( container );

        }

    }

    function checkAndHideElementFromCookie(formID,container){
        let hide = getCookie('close_form_'+formID);
        if(hide){
            container.remove();
        }
    }

    function hideElementInCookie(formID){
        setCookie('close_form_'+formID,true,3);
    }

    const db_KlaviyoMountCloseButton = debounce( KlaviyoMountCloseButton, 250 );

    function initKlaviyoFormCustomisation(){
        window.addEventListener("klaviyoForms", function(e) { 
            if (e.detail.type == 'open') {
                // Custom JS
                waitForElm("button.needsclick.kl-teaser-"+e.detail.formId).then((button) => {
                    if(button){
                        db_KlaviyoMountCloseButton( button );
                    }
                });


                
            }
            if (e.detail.type == 'close') {
                
                waitForElm("button.needsclick.kl-teaser-"+e.detail.formId).then((button) => {
                    if(button){
                        db_KlaviyoMountCloseButton( button );
                    }
                });

            }
        });
        
        waitForElm("button.needsclick").then((elm) => {
            if (elm.className.includes("kl-teaser-")) {
                const formID = elm.className.match(/kl-teaser-(\w+)/)[1];
                let button = document.querySelector("button.needsclick.kl-teaser-"+formID);
                if(button){
                    db_KlaviyoMountCloseButton( button );
                }
            }

        });

        const extraPaymentBtnsSection = document.querySelector('.extra-payment-btns-section');

        if (extraPaymentBtnsSection) {
        extraPaymentBtnsSection.addEventListener('click', (event) => {
            if (!event.target.classList.contains('modal-link')) {
                const buyBtnModal = document.querySelector('.buy-btn-modal.active');
                if (buyBtnModal) {
                    if (!event.target.closest('.modal-bg.affirm')) {                        
                            buyBtnModal.classList.remove('active');   
                    }
                }
            }
        });

        const mainElement = document.querySelector('main');
        const affirmElement = document.querySelector('.affirm.buy-btn-modal');
        const afterpayElement = document.querySelector('.afterpay.buy-btn-modal');
        mainElement.appendChild(affirmElement);
        mainElement.appendChild(afterpayElement);

        const modals = document.querySelectorAll('.buy-btn-modal.hidden');
  
        modals.forEach(modal => {
          modal.addEventListener('click', function(event) {
            // Check if the modal has the 'active' class
            if (modal.classList.contains('active')) {
              // Check if the click target is the modal itself, not a child element
              if (event.target === modal) {
                modal.classList.remove('active');
              }
            }
          });
        });
        }


    }


      const quickAddIconView = function() {
        const quickAddButtons = document.querySelectorAll('.product-card__quick-add-button');
        const searchQuick = document.querySelectorAll('.add-to-cart-quickview');
    
        quickAddButtons.forEach(button => {
          const productCard = button.closest('.product-card');
          
          if (productCard) {
            const figure = productCard.querySelector('.product-card__figure');
            
            if (figure && !figure.contains(button)) {
              figure.appendChild(button);
            }
          }
        });
    
        searchQuick.forEach(button => {
          const productCard = button.closest('.product-card');
          
          if (productCard) {
            const figure = productCard.querySelector('.product-card__figure');
            
            if (figure && !figure.contains(button)) {
              figure.appendChild(button);
            }
          }
        });
      };

      if (document.querySelector(".product-list") && window.matchMedia('(hover: hover)').matches) {
        // quickAddIconView(); 
      }


    function checkoutProgressBarDomCheck() {
        let progressBarLabel = document.querySelector('.rebuy-cart__progress-bar-prompt');
        let checker = document.querySelector(".rebuy-cart__flyout-subtotal");
        let avail = document.querySelector(".shipping.rebuy-cart__flyout-subtotal");
    
        if (progressBarLabel) {
          let content = progressBarLabel.innerHTML;
          let newContent = '';
    
          let amountMatch = content.match(/\$(\d+\.\d{2})/);
          if (amountMatch) {
            if( document.querySelector('html').getAttribute('lang') == 'fr' ){
                let amount = amountMatch[0];
                if (content.includes('away from')) {
                  newContent = `Ajouter ${amount} pour une Livraison Gratuite`;
                } else if (content.includes("You've unlocked")) {
                  newContent = 'Livraison Gratuite';
                } else {
                  newContent = 'Livraison Gratuite';
                }
            }else{
                let amount = amountMatch[0];
                if (content.includes('away from')) {
                  newContent = `Add ${amount} for Free Shipping`;
                } else if (content.includes("You've unlocked")) {
                  newContent = 'Livraison Gratuite';
                } else {
                  newContent = 'Livraison Gratuite';
                }
            }

          } else {
            if( document.querySelector('html').getAttribute('lang') == 'fr' ){
                newContent = 'Livraison Gratuite';
            }else{
                newContent = 'Free Shipping';
            }
            
          }
          let newHTML = "";
          if( document.querySelector('html').getAttribute('lang') == 'fr' ){
            newHTML = `
            <div class="rebuy-cart__flyout-subtotal shipping" bis_skin_checked="1">
              <div class="rebuy-cart__flyout-subtotal-label" bis_skin_checked="1"><span>Livraison</span></div>
              <div class="rebuy-cart__flyout-subtotal-amount" bis_skin_checked="1">${newContent}</div>
            </div>`;
          }else{
            newHTML = `
            <div class="rebuy-cart__flyout-subtotal shipping" bis_skin_checked="1">
              <div class="rebuy-cart__flyout-subtotal-label" bis_skin_checked="1"><span>Shipping</span></div>
              <div class="rebuy-cart__flyout-subtotal-amount" bis_skin_checked="1">${newContent}</div>
            </div>`;
          }

    
          if (!avail) {
            checker.insertAdjacentHTML('beforebegin', newHTML);
          } else {
            avail.querySelector('.rebuy-cart__flyout-subtotal-amount').innerHTML = newContent;
          }
        }
        
      }

      function initCheckoutProgressBarWatchers() {
        waitForElm('.rebuy-cart__progress-bar-prompt').then((elm) => {
          checkoutProgressBarDomCheck();
        });
        waitForElm('.rebuy-cart__progress-step').then((element) => {
          const observer = new MutationObserver(() => {
              checkoutProgressBarDomCheck()
            });
            const config = {
              childList: true, // Observe changes to the element's children
              attributes: true, // Observe changes to the element's attributes
              characterData: true, // Observe changes to the element's text content
            };
            observer.observe(element, config);
        });
        waitForElm("#rebuy-cart").then((elm) => {
          checkoutProgressBarDomCheck();
        });
        window.addEventListener("cart_changed", function(e){
          checkoutProgressBarDomCheck()
        });
      }

      if (window.trilogPerformance.isCollectionPage) {
        window.trilogPerformance.runWhenIdle(initCheckoutProgressBarWatchers, 2000);
      } else {
        initCheckoutProgressBarWatchers();
      }
      
      const handleSearchInputChange = (event) => {
        const inputValue = event.target.value.trim();
        const headerSearchElement = document.querySelector('.header-search');
        // You can add your search logic here
        if (inputValue) {
          headerSearchElement.classList.add('searched');
        } else {
            headerSearchElement.classList.remove('searched');
        }
  
    };

      waitForElm(".header-search__input").then((elm) => {
        elm.addEventListener('input', debounce(handleSearchInputChange, 300));
    });

    function getUrlParameter(name) {
        const params = new URLSearchParams(window.location.search);
        return params.get(name);
    }

    function setHandlerforCollectionLinks(){
      $(".removable-facet .tap-area").off('click.trilogFilterLinks').on('click.trilogFilterLinks',function(){
        runAfterPaint(function () {
          // Get the filter price parameter
          let filterPrice = getUrlParameter('filter.v.price.lte');

          if (filterPrice !== null) {
              // Loop through each anchor with the specified class
              $('.collection-quick-link-container').each(function () {
                  let href = $(this).attr('href');
                  if (href.includes(`filter.v.price.lte=${filterPrice}`)) {
                      $(this).addClass('active_link_page');
                  }else{
                    $(this).removeClass('active_link_page');
                  }
              });
          }else{
            $('.collection-quick-link-container').removeClass('active_link_page')
          }
        });
      })
    }

    /*function setMenuSaleToRed(){
      $('.header__primary-nav-item summary').each(function () {
          let text = $(this).text();
          if (text.toLowerCase().includes("sale") || text.toLowerCase().includes("soldes")) {
            this.style.color = "#C8102E";
          }
      });
    }*/

    document.addEventListener("DOMContentLoaded", function() {
        
        if( $('#pdp-glow-points').length ){
            initPDPGlowPointsModal();
        }
        window.trilogPerformance.runWhenIdle(initKlaviyoFormCustomisation, 2500);

        if( $('#pdp-glow-points').length ){

        }

        if ($(".removable-facet .tap-area").length) {
          setHandlerforCollectionLinks();
        };

        if ($(".header__primary-nav-item").length) {
          //setMenuSaleToRed();
        };


      if (document.querySelector('.alphabet-item button, .brand-group')) {
      //Trilog Brands Page JS - Alphabet Click Scroll
      const alphabetButtons = document.querySelectorAll('.alphabet-item button');
    
      alphabetButtons.forEach(button => {
        button.addEventListener('click', function () {
          const letter = this.getAttribute('data-letter');
          const targetSection = document.getElementById(letter === '#' ? 'numbers-symbols' : letter);
    
          if (targetSection) {
            const offset = 100; // Adjust this to match your sticky header height
            const elementPosition = targetSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    
      //Trilog Brands Page JS - Column Logic
        const brandGroups = document.querySelectorAll('.brand-group');
    
      function updateBrandGroupClasses() {
        brandGroups.forEach(group => {
          group.classList.remove('one', 'two', 'three', 'four');
    
          if (window.innerWidth <= 768) {
            group.classList.add('one'); // Define `.one` if needed
          } else if (window.innerWidth <= 1025) {
            group.classList.add('two'); // Define `.one` if needed
          }else {
            group.classList.add('four'); // Default desktop layout
          }
        });
      }
    
      if (brandGroups.length) {
        updateBrandGroupClasses();
        window.addEventListener('resize', updateBrandGroupClasses);
      }
      }
      
    })
    
    
})();

(() => {

       const alphabetContainer = document.querySelector('[data-section-id="pf-b797"]');
       if( alphabetContainer ){
    const divs = document.querySelectorAll(".sc-dtDOqo > div");
       const alphabet = "ABCDEFGHIJKLMNOPRSTUVWYZ";
       let alphabetIndex = 0;
        let offsetheight = alphabetContainer.getBoundingClientRect().height;

        function scrollToElement(id) {
            const element = document.getElementById(id);
            if (element) {
                const offsetTop = element.getBoundingClientRect().top + window.scrollY - offsetheight;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }
    
        const links = document.querySelectorAll(".pf-c .letterTxt");
        links.forEach(link => {
                if (! link.hasAttribute('data-target')) {
                    link.addEventListener("click", function(event) {
                        event.preventDefault();
                        const targetId = this.getAttribute("href").substring(1); // Get the target ID from the href attribute
                        scrollToElement(targetId);
                    });
                }
        });
       }
        
   
   })();

const openModal = (whichModal) => {
    const afterpayModal = document.querySelector(".afterpay.buy-btn-modal");
    const affirmModal = document.querySelector(".affirm.buy-btn-modal");
    const afterpayModalBg = document.querySelector(".modal-bg.afterpay");
    const affirmModalBg = document.querySelector(".modal-bg.affirm");

    if (whichModal == 'afterpay') {
      if (afterpayModal.classList.contains("active")) {
        afterpayModal.classList.remove("active");

      } else {
        afterpayModal.classList.add("active");

      }
    }
    if (whichModal == 'affirm') {
      if (affirmModal.classList.contains ("active")) {
        affirmModal.classList.remove("active");

      } else {
        affirmModal.classList.add("active");
        
      }
    }
  }

  function scrollToTopInShadowRoot(shadowHostSelector) {
    const shadowHost = document.querySelector(shadowHostSelector);
    
    if (shadowHost && shadowHost.shadowRoot) {
      const shadowRoot = shadowHost.shadowRoot;
      
      // Get the scrollable div
      const scrollableDiv = shadowRoot.querySelector('.scrollable');
      
      if (scrollableDiv) {
        // Get the slotted content
        const slottedContent = scrollableDiv.assignedNodes({ flatten: true });
  
        // Scroll the first child (or any specific child) to the top
        if (slottedContent.length > 0) {
          slottedContent[0].scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      }
    }
  }
/* ============================
 * EMPTY MENU (no flicker)
 * ============================ */
(() => {
  const startEmptyMenu = () => {
  let originalShopTrending = null;
  let insertQueued = false;

  const waitForElm = (selector) =>
    new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const obs = new MutationObserver(() => {
        const el2 = document.querySelector(selector);
        if (el2) {
          obs.disconnect();
          resolve(el2);
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });
    });

  const getOrCloneTrending = () => {
    const existing = document.querySelector("#shop-trending-cart");
    if (existing) return existing;
    if (originalShopTrending) return originalShopTrending.cloneNode(true);
    return null;
  };

  const setReady = (ready) => {
    document.documentElement.classList.toggle("empty-trending-ready", !!ready);
  };

  const insertShopTrending = async () => {
    if (!originalShopTrending && !document.querySelector("#shop-trending-cart")) return;

    const emptyCart = await waitForElm(".rebuy-cart__flyout-empty-cart");

    // If Rebuy empty-cart container exists, we are in empty-cart UI
    const isEmpty = !!document.querySelector(".rebuy-cart__flyout-empty-cart");

    const trending = getOrCloneTrending();
    if (!trending) return;

    if (!isEmpty) {
      // cart has items: ensure it's hidden (and keep page class off)
      trending.style.display = "none";
      setReady(false);
      return;
    }

    // empty cart: move it inside empty cart container and show
    if (!emptyCart.contains(trending)) emptyCart.appendChild(trending);

    trending.style.display = "block";
    setReady(true);
  };

  const captureTrendingAndInsert = () => {
    const existing = document.querySelector("#shop-trending-cart");
    if (existing) originalShopTrending = existing.cloneNode(true);

    insertShopTrending();
  };

  // Capture original HTML early
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", captureTrendingAndInsert, { once: true });
  } else {
    captureTrendingAndInsert();
  }

  // Observe changes
  const queueInsertShopTrending = () => {
    if (insertQueued) return;

    insertQueued = true;
    requestAnimationFrame(() => {
      insertQueued = false;
      insertShopTrending();
    });
  };

  const obs = new MutationObserver(queueInsertShopTrending);
  obs.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("cart_changed", queueInsertShopTrending);
  };

  window.trilogPerformance.runWhenIdle(startEmptyMenu, 2000);
})();

/* ============================
 * SALE PRICE
 * ============================ */
  document.addEventListener("DOMContentLoaded", function() {
    let $salePriceElement = document.querySelector("sale-price");

    if ($salePriceElement) {
        const formElement = document.forms[$salePriceElement.getAttribute("form")];

        if (formElement) {
            formElement.addEventListener("variant:change", (event) => {
                const variant = event.detail.variant;
                if (variant) {
                    const installmentPrice = (variant.price / 100 / 4).toFixed(2);
                    
                    let elements = document.querySelectorAll(".extra-payment-installment");
                    elements.forEach(element => {
                        const template = element.getAttribute("data-template");
                        const updatedText = template.replace("{price}", installmentPrice);
                        element.innerText = updatedText;
                    });
                }
            });
        }
    }
});

/* ============================
 * Brands Alpha Menu (V2, scoped)
 * Root class: .brands-alpha-menu
 * ============================ */

/* Safely escape IDs for querySelector */
window.CSS && CSS.escape || (window.CSS = { escape: s => String(s).replace(/([ !"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, '\\$1') });

function changeAlphabetV2(el) {
  const $menu = $(el).closest('.brands-alpha-menu');     // <-- scope to this menu only
  if (!$menu.length) {                                   // fallback to old behavior if not inside V2
    return changeAlphabet(el);
  }

  // 1) letter selected state
  $menu.find('.brand-letter').removeClass('selected');
$(el).addClass('selected');
  // 2) resolve target panel id from data-target or href
  let id = $(el).data('target') || $(el).attr('href') || '';
  id = id.replace(/^#/, '');
  if (!id) return;

  // 3) toggle active holder inside this menu only
  const $holder = $menu.find('#' + CSS.escape(id));
  if (!$holder.length) return;

  $menu.find('.LinkHolder').removeClass('active');
  $holder.addClass('active');
}

$(function () {
  // Ensure one active panel per V2 menu on load (mirrors old behavior)
  $('.brands-alpha-menu').each(function () {
    const $m = $(this);
    if (!$m.find('.LinkHolder.active').length) {
      $m.find('.LinkHolder').first().addClass('active');
    }
  });
});

// Click: intercept only when it's a panel toggle (data-target or #hash)
$(document).on('click', '.brands-alpha-menu .brand-letter', function (e) {
  const href      = this.getAttribute('href') || '';
  const hasPanel  = $(this).data('target') || href.startsWith('#');
  const allowNav  = $(this).is('[data-navigate], .brand-link') || (!hasPanel && href && !href.startsWith('#'));

  if (allowNav) return;           // let real links navigate normally

  if (hasPanel) {                 // toggle panel behavior
    e.preventDefault();
    e.stopPropagation();
    changeAlphabetV2(this);
  }
});

// Hover: only swap when it's a panel toggle; ignore real links
$(document).on('mouseenter', '.brands-alpha-menu .brand-letter', function () {
  const href     = this.getAttribute('href') || '';
  const hasPanel = $(this).data('target') || href.startsWith('#');
  if (!hasPanel) return;          // don't hover-swap on real links

  const $menu = $(this).closest('.brands-alpha-menu');
  clearTimeout($menu.data('bamTimer'));
  const that = this;
  $menu.data('bamTimer', setTimeout(function(){ changeAlphabetV2(that); }, 150));
}).on('mouseleave', '.brands-alpha-menu .brand-letter', function () {
  const $menu = $(this).closest('.brands-alpha-menu');
  clearTimeout($menu.data('bamTimer'));
});


/* ============================
 * PROMO BLOCK
 * ============================ */
(() => {
  const sectionId = "{{ section.id }}";
  if (sectionId.indexOf("{{") !== -1) return;

  const root = document.getElementById(`shopify-section-${sectionId}`) || document;
  const listId = `product-list-${sectionId}`;
  const MOBILE_BP = 699;

  const PROMO_SELECTOR = '[data-promo-node="true"][data-promo-block-id]';
  const isMobile = () => window.matchMedia(`(max-width:${MOBILE_BP}px)`).matches;

  const getList = () => root.querySelector(`#${CSS.escape(listId)}`);

  const getPromoInsideTile = (tile) =>
    tile.matches?.(PROMO_SELECTOR) ? tile : tile.querySelector?.(PROMO_SELECTOR);

  const isHiddenForBreakpoint = (promoEl, mobile) => {
    return mobile
      ? promoEl.classList.contains("hide-on-mobile")
      : promoEl.classList.contains("hide-on-desktop");
  };

const getSpan = (promoEl, mobile) => {
  const attr = mobile ? "data-span-mobile" : "data-span-desktop";
  const span = parseInt(promoEl.getAttribute(attr) || "1", 10);
  return Number.isFinite(span) && span > 0 ? span : 1;
};

  const getPos = (promoEl, mobile) => {
    const attr = mobile ? "data-pos-mobile" : "data-pos-desktop";
    const pos = parseInt(promoEl.getAttribute(attr) || "", 10);
    return Number.isFinite(pos) && pos > 0 ? pos : 1;
  };

  let applying = false;

  const snapshotOriginalOrder = (tiles) => {
    tiles.forEach((tile, i) => {
      if (!tile.dataset.origIndex) tile.dataset.origIndex = String(i);
    });
  };

  const restoreDesktopOrder = (list, tiles) => {
    const sorted = [...tiles].sort((a, b) => {
      const ai = parseInt(a.dataset.origIndex || "0", 10);
      const bi = parseInt(b.dataset.origIndex || "0", 10);
      return ai - bi;
    });
    list.replaceChildren(...sorted);
  };

  const applyMobileOrder = (list, tiles) => {
    const promos = [];
    const products = [];
    const ghosts = [];

    tiles.forEach((tile, order) => {
      const promoEl = getPromoInsideTile(tile);

      if (promoEl) {
        if (isHiddenForBreakpoint(promoEl, true)) {
          ghosts.push(tile);
          return;
        }

        promos.push({
          tile,
          order,
          pos: getPos(promoEl, true),
          span: getSpan(promoEl, true),
        });
      } else {
        products.push(tile);
      }
    });

    if (!promos.length) return;

    const byPos = new Map();
    let promoCellsTotal = 0;
    let maxPromoEnd = 0;

    promos.forEach((p) => {
      promoCellsTotal += p.span;
      maxPromoEnd = Math.max(maxPromoEnd, p.pos + p.span - 1);
      if (!byPos.has(p.pos)) byPos.set(p.pos, []);
      byPos.get(p.pos).push(p);
    });

    for (const arr of byPos.values()) arr.sort((a, b) => a.order - b.order);

    const maxIndex = Math.max(products.length + promoCellsTotal, maxPromoEnd);

    const next = [];
    let productPointer = 0;
    let skipCells = 0;

    for (let idx = 1; idx <= maxIndex; idx++) {
      if (skipCells > 0) { skipCells--; continue; }

      const promosHere = byPos.get(idx);
      if (promosHere && promosHere.length) {
        let maxSpanHere = 1;

        promosHere.forEach((p) => {
          next.push(p.tile);
          maxSpanHere = Math.max(maxSpanHere, p.span);
        });

        skipCells = Math.max(0, maxSpanHere - 1);
        continue;
      }

      if (productPointer < products.length) {
        next.push(products[productPointer++]);
      } else {
        break;
      }
    }

    tiles.forEach((t) => {
      if (!next.includes(t) && !ghosts.includes(t)) next.push(t);
    });

    ghosts.forEach((t) => {
      if (!next.includes(t)) next.push(t);
    });

    list.replaceChildren(...next);
  };

  const rebuild = () => {
    if (applying) return;

    const list = getList();
    if (!list) return;

    const tiles = Array.from(list.children).filter(n => n && n.nodeType === 1);
    if (!tiles.length) return;

    applying = true;

    snapshotOriginalOrder(tiles);

    if (isMobile()) {
      applyMobileOrder(list, tiles);
    } else {
      restoreDesktopOrder(list, tiles);
    }

    applying = false;
  };

  const run = () => requestAnimationFrame(() => requestAnimationFrame(rebuild));

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:select", run);
  document.addEventListener("shopify:section:deselect", run);

  let t;
  window.addEventListener("resize", () => {
    clearTimeout(t);
    t = setTimeout(run, 120);
  }, { passive: true });

  const observer = new MutationObserver(() => run());
  observer.observe(root, { childList: true, subtree: true });
})();


document.addEventListener('change', function (e) {
  const input = e.target;
  if (!input.matches('input[type="radio"]')) return;

  // Find the label that targets this input
  const label = document.querySelector('label.thumbnail-swatch[for="' + CSS.escape(input.id) + '"]');
  if (!label) return;

  // Limit to the option group (fieldset is common in Prestige)
  const group = label.closest('fieldset, [data-option-values], .product-form__option-values') || label.parentElement;

  // Remove old selected
  group.querySelectorAll('label.thumbnail-swatch.is-selected')
    .forEach(el => el.classList.remove('is-selected'));

  // Add selected to the current one
  label.classList.add('is-selected');
});

(function(){
  const lang = (document.documentElement.lang || '').toLowerCase();
  if(!lang.startsWith('fr')) return;

  const map={
    "Notify me when back in stock":"M’avertir du retour en stock",
    "Notify when Back in Stock":"M’avertir du retour en stock",
    "Notify Me!":"M’avertir",
    "Phone Number":"Numéro de téléphone",
    "No thanks":"Non merci",
    "Text me instead":"Recevoir un SMS plutôt",
    "This field is required":"Ce champ est obligatoire",
    "You're all set!":"C’est noté !",
    "Keep an eye out for a back-in-stock message.":"Surveillez votre boîte de réception pour être avisé du retour en stock.",
    "Notify when" : "M’aviser lorsque l’article sera",
    "Back in Stock" : "de retour en stock",
    "Receive a text message for when this item comes back in stock." : "Recevez un message texte lorsque cet article sera de retour en stock.",
    "Enter your email address": "Entrez votre adresse courriel",
    "Subscribe to promotional emails": "S’abonner aux courriels promotionnels",
    "I would also like to receive promotional emails." : "J’aimerais également recevoir des courriels promotionnels.",
    "By submitting this form and signing up for texts, you consent to receive marketing text messages (e.g. promos, cart reminders) from Boutique Skin Envie at the number provided, including messages sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). ":"En soumettant ce formulaire et en vous inscrivant aux messages textes, vous consentez à recevoir des messages textes promotionnels (p. ex. promotions, rappels de panier) de la part de Boutique Skin Envie au numéro fourni, y compris des messages envoyés à l’aide d’un composeur automatique. Le consentement n’est pas une condition d’achat. Des frais de messagerie et de données peuvent s’appliquer. La fréquence des messages varie. Vous pouvez vous désabonner en tout temps en répondant STOP ou en cliquant sur le lien de désabonnement (lorsqu’il est disponible)."
  };

  function translate(){
    document.querySelectorAll('button[data-a11y-identifier^="bis-button-"], .klaviyo-bis-trigger, .klaviyo-form button, .klaviyo-form input[placeholder], .klaviyo-form span, input[placeholder][class*="go"], label[class*="go"], .klaviyo-form legend, legend[class*="klaviyo"], .klaviyo-form p, div[class*="go"] p')
      .forEach(el=>{
        const text = (el.textContent || '').trim();
        
        // Special case for elements containing links that need URL updates
        if(text.includes("By submitting this form") && text.includes("Privacy Policy")) {
          let html = el.innerHTML;
          
          // Replace URL paths first
          html = html.replace(/href="https:\/\/bskinenvie\.ca\/pages\/privacy-policy"/g, 'href="https://bskinenvie.ca/fr/pages/privacy-policy"');
          html = html.replace(/href="https:\/\/bskinenvie\.ca\/pages\/terms-conditions"/g, 'href="https://bskinenvie.ca/fr/pages/terms-conditions"');
          
          // Replace link text
          html = html.replace(/Privacy Policy/g, 'Politique de Confidentialité');
          html = html.replace(/>Terms</g, '>Termes & Conditions<');
          
          // Replace the main text - everything before the first <a tag
          const frenchText = 'En soumettant ce formulaire et en vous inscrivant aux messages textes, vous consentez à recevoir des messages textes promotionnels (p. ex. promotions, rappels de panier) de la part de Boutique Skin Envie au numéro fourni, y compris des messages envoyés à l\'aide d\'un composeur automatique. Le consentement n\'est pas une condition d\'achat. Des frais de messagerie et de données peuvent s\'appliquer. La fréquence des messages varie. Vous pouvez vous désabonner en tout temps en répondant STOP ou en cliquant sur le lien de désabonnement (lorsqu\'il est disponible). ';
          
          // Get everything from the first <a tag onwards and prepend French text
          const firstATagIndex = html.indexOf('<a');
          
          if (firstATagIndex > -1) {
            const linkHTML = html.substring(firstATagIndex);
            html = frenchText + linkHTML;
          }
          
          el.innerHTML = html;
        } else if(map[text]) {
          el.textContent = map[text];
        }

        if(el.placeholder && map[el.placeholder]) {
          el.placeholder = map[el.placeholder];
        }
      });
  }

  function startTranslateObserver() {
    let queued = false;
    const queueTranslate = () => {
      if (queued) return;

      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        translate();
      });
    };

    new MutationObserver(queueTranslate).observe(document.body,{
      childList:true,
      subtree:true
    });

    translate();
  }

  window.trilogPerformance.runWhenIdle(startTranslateObserver, 2500);
})();
